import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

function Foundry() {
  // Footer
  useEffect(() => {
    const footer = document.querySelector(".footer-contain");
    footer.className = "footer-contain";
  }, []);

  // Navs and Footer
  useEffect(() => {
    const nav = document.querySelector(".navigation-large");
    nav.className =
      "navigation-large d-none d-md-flex justify-content-between fixed-top section-bg";
  }, []);

  useEffect(() => {
    const nav = document.querySelector(".navigation-small");
    nav.className =
      "navigation-small d-flex justify-content-between d-md-none fixed-top section-bg";
  }, []);

  useEffect(() => {
    const footer = document.querySelector(".footer-contain");
    footer.className = "footer-contain section-bg";
  }, []);

  return (
    <>
      <Container className="section-contain">
        <Helmet>
          <body className="section-bg" />
          <title>Foundry - GarageFonts</title>
          <meta property="og:title" content="Foundry - GarageFonts" />
        </Helmet>
        <Row>
          <Col md={12}>
            <h1 className="header">About</h1>
          </Col>
        </Row>
        <Row>
          <Col lg={7}>
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <Link to="/foundry" className="nav-link active">
                  Foundry
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/contact" className="nav-link">
                  Contact
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/colophon" className="nav-link">
                  Colophon
                </Link>
              </li>
            </ul>
          </Col>
        </Row>
        <Row>
          <Col lg={7} className="mt-4">
            <p>
              GarageFonts is an independent type foundry based in Pittsburgh,
              PA. Founded in 1993 as a vehicle to distribute typeface designs
              created for Ray Gun magazine, GarageFonts has always released
              fonts that are unique and purpose-driven. We aim to build on this
              legacy as we forge an eclectic offering of fonts, both pragmatic
              and experimental.
            </p>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Foundry;
